export default __webpack_public_path__ + "static/media/ico-promo.642bf70b.svg";